module.exports = __webpack_public_path__ + "img/icon-attachment-18.a0b0993d.svg";